<template>
  <div class="card-curvey">
    <h2>Overall Campaigns</h2>
    <v-layout row nowrap class="align-center mt-3">
      <v-flex xs6>
        <apex-chart
          type="donut"
          height="250"
          :options="chartOptions"
          :series="series"
        ></apex-chart>
      </v-flex>

      <v-flex xs6>
        <div class="legends-list">
          <graph-legend
            :color="$vuetify.theme.warning"
            label="Sent"
            :value="getRation('sent')"
          />
          <graph-legend
            color="grey"
            label="Delivered"
            :value="getRation('delivered')"
          />
          <graph-legend
            color="#2196f3"
            label="Read"
            :value="getRation('read')"
          />
          <graph-legend
            :color="$vuetify.theme.secondary"
            label="Replied"
            :value="getRation('reply back')"
          />
          <graph-legend
            color="#ff5252"
            label="Failed"
            :value="getRation('failed')"
          />
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import apexChart from "vue-apexcharts";
import graphLegend from "./graphLegend";

export default {
  name: "overallCampaignsPieChart",
  components: {
    apexChart,
    graphLegend,
  },
  props: {
    overallData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        colors: [
          this.$vuetify.theme.warning,
          "grey",
          "#2196f3",
          this.$vuetify.theme.secondary,
          "#ff5252",
        ],
        legend: {
          show: false,
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  offsetY: -1,
                  show: true,
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "#000",
                },
              },
            },
          },
        },
        labels: [],
        chart: {
          type: "donut",
          toolbar: {
            show: true,

            export: {
              csv: {
                filename: undefined,
                headerCategory: "Category",
                headerValue: "Value",
              },
            },
          },
        },
      },
    };
  },

  watch: {
    overallData: {
      handler(newVal) {
        this.updateChart(newVal);
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    updateChart(data) {
      // Rebuild series from scratch
      this.series = data.map((item) => item.count);

      // Rebuild labels from scratch
      const labels = data.map((item) => item.label);

      // Replace chartOptions with a new object so Apex sees the change
      this.chartOptions = {
        ...this.chartOptions,
        labels,
      };
    },

    getRation(label) {
      const obj = this.overallData.find(
        (item) => item.label.toLowerCase() === label
      );

      if (obj) {
        return obj.ratio;
      }
      return 0;
    },
  },
};
</script>

<style scoped>
.card-curvey {
  height: calc(100% - 60px);
}
</style>
